// extracted by mini-css-extract-plugin
export var fadeIn = "_mp-1";
export var modalContent = "_mp-3";
export var overlay = "_mp-0";
export var popoverContent = "_mp-2";
export var results = "_mp-5";
export var searchInputWrapper = "_mp-4";